import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AgendaService } from '../services/agenda.service';
import { EmployeeService } from '../../employee/services/employee.service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { Router } from '@angular/router';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-stat-count',
    templateUrl: './stat-count.component.html',
    styleUrls: ['./stat-count.component.scss'],
    standalone: false
})
export class StatCountComponent implements OnInit {

  public empresaId: number;
  public todaytaskCount = 0;
  public todayActuacionCount = 0;

  constructor(
    public agendaService: AgendaService,
    public employeeService: EmployeeService,
    public empresaTreeViewService: EmpresaTreeViewService,
    public router: Router,
    private sharedService: SharedService,
    public snackBar: MatSnackBar,
    private cdRef: ChangeDetectorRef) {
    this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
      if (_res > 0) {
        this.getCount(_res);
      }
    });
    this.subscribeEvents();
  }

  ngOnInit(): void {
    this.empresaId = JSON.parse(localStorage.getItem('Empresa'));
  }

  public subscribeEvents(): void {
    this.agendaService.tareasHoyCount.subscribe((res) => {
      this.todaytaskCount = res && res >= 0 ? res : 0;
    });
    this.agendaService.atuacionesCount.subscribe((res) => {
      this.todayActuacionCount = res && res >= 0 ? res : 0;
    });
  }

  ngAfterViewInit(): void {
    this.getCount(this.empresaId);
    this.cdRef.detectChanges();
  }

  getCount(empresaId): void {
    this.agendaService.getBajasActivasCount(empresaId).then(
      res => {
        this.agendaService.getTareasHoyCount(empresaId).then(res => {
          this.agendaService.getActuacionesCount(empresaId);
        });
      }
    );
  }

  public NavigateToTaskSelection(): void {
    if (this.sharedService.selectionTabList.filter(e => e.id === 5 && e.isPermit).length > 0) {
      this.sharedService.selectedSelectionTabId = 5;
      this.router.navigate(['/selection-view']);
    } else {
      this.showSnackBar('Permission denied', '', 2500);
    }
  }

  public showSnackBar(message: string, action: string, duration: number): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, action, {
      duration: duration
    });
  }

}
